module.exports = "/assets/c7812c43f455520657798933e523f70f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/v2-icons/trolley.svg
// module id = 3321
// module chunks = 0